import {
    ORDER_LIST_VENDEUR_FAIL,
    ORDER_LIST_VENDEUR_REQUEST,
    ORDER_LIST_VENDEUR_SUCCESS,
} from '../constants/orderConstants';
  
  export const vendeurOrdersReducer = (state = { orders: [] }, action) => {
    switch (action.type) {
      case ORDER_LIST_VENDEUR_REQUEST:
        return { loading: true, orders: [] };
      case ORDER_LIST_VENDEUR_SUCCESS:
        return { loading: false, orders: action.payload };
      case ORDER_LIST_VENDEUR_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };
